import { DAPI_CACTUS_HOST } from '../../config/index';

const getNpiCheckUrl = () => {
  return `${DAPI_CACTUS_HOST}/v1/insurance-coverage`;
};

export { getNpiCheckUrl };
